import { render, staticRenderFns } from "./threejs4.vue?vue&type=template&id=5ac88cb3&scoped=true"
import script from "./threejs4.vue?vue&type=script&lang=js"
export * from "./threejs4.vue?vue&type=script&lang=js"
import style0 from "./threejs4.vue?vue&type=style&index=0&id=5ac88cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac88cb3",
  null
  
)

export default component.exports